<!-- 修改密码 -->
<template>
<div class="password-page">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <el-row>
            <el-col :span="12">
                <el-form-item label="手机号" prop="phone"  >
                    <el-input v-model="ruleForm.phone" @input="handlePhone"
                        placeholder="手机号" maxlength="11" />
                </el-form-item>
            </el-col> 
            <el-col :span="12">
                <el-form-item label="验证码" prop="varifyCode" >
                    <el-input v-model="ruleForm.varifyCode" placeholder="验证码" maxlength="6">
                        <template slot="append">
                            <el-button @click="sendPhoneCode" :disabled="disabledCode">{{ codeMsg }}</el-button>
                        </template>
                    </el-input>
                </el-form-item> 
            </el-col>           
        </el-row>  
        <el-row>
            <el-col :span="12">
                <el-form-item label="新密码" prop="newPassword" >
                    <el-input v-model="ruleForm.newPassword" :type="pwType2" @input="pwInput2"
                        placeholder="请输入新密码" autocomplete="new-password" maxlength="20"/>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="确认密码" prop="confirmPassword" >
                    <el-input :type="pwType3" @input="pwInput3"
                    v-model="ruleForm.confirmPassword"                    
                    placeholder="请输入确认密码"
                    autocomplete="new-password"
                    maxlength="20" />
                    </el-form-item>
                </el-col>    
        </el-row> 
        <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" >提交</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>    
    </el-form>
</div>
</template>
<script>
export default {
    components:{
       
    },
    data() {
        var validatePass =(rule, value, callback)=>{
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.newPassword) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        }
        return {
            ruleForm:{
                phone: '',
                varifyCode: '',
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
            },
            rules:{
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { min: 3, max: 11, message: '长度在 11 位字符', trigger: 'blur' }
                ],
                varifyCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { min: 3, max: 6, message: '长度在 3 到 6 个字符', trigger: 'blur' }
                ],
                oldPassword: [
                    { required: false, message: '请输入原密码', trigger: 'blur' },
                ],
                newPassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在6-20个字符', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请输入确认密码', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur' }
                ],
            },
            pwType1: 'text',
            pwType2: 'text',
            pwType3: 'text',
            pwKey: 0,     
            codeMsg: '发送验证码',
            seconds: 120,
            timer: null,
            disabledCode: false,   
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        },
        isLogin(){           
            return  localStorage.getItem('isLogin')
        }   
    },
    created() {
        if(this.isLogin !== '0'){
            this.$router.replace({ path: "/login" });
        }
    },
    mounted() {

    },
    methods: {
        handleSubmit(){ 
            let { phone,varifyCode,newPassword,confirmPassword} = this.ruleForm
            let params = {
                opcode: this.$code.ModifyPassCode,
                phone_no: phone,
                v_verify_code: varifyCode,
                v_new_pass: newPassword,
                new_pass_repeat: confirmPassword,
            }

            this.$api.requestAPI(params).then(res =>{                
                if(res.IsSuccess){
                    this.$message.success("密码修改成功，请重新登录")    
                    localStorage.clear();
                    
                    setTimeout(()=>{
                        this.$router.replace({ path: "/login" });
                    },500)                    
                }else{
                    this.$message.error(res.Message) 
                }
            }).catch( err =>{
                console.log(err)
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.handleSubmit()
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },       
        sendPhoneCode() {
            if (this.ruleForm.phone == '') {
                this.$message.error('请输入手机号');
                return false;
            }
            if (!this.$help.isMobile(this.ruleForm.phone)) {
                this.$message.error('请输入正确的手机号');
                return false;
            }
            let params = {
                opcode: this.$code.SMS,
                v_phone: this.ruleForm.phone,
            }
    
            this.$api._requestAPI(params).then(res => {
                if (res.IsSuccess) {
                    this.$message.success('发送成功')
                } else {
                    this.$message.error(res.Message)
                }
            }).catch(err => {
                console.log(err);
            })
    
            this.timer = setInterval(() => {
                if (this.seconds == 0) {
                    clearInterval(this.timer);
                    this.disabledCode = false;
                    this.codeMsg = '重新发送';
                    this.seconds = 120;
                } else {
                    this.seconds--
                    this.disabledCode = true;
                    this.codeMsg = this.seconds + '秒后重发'
                }
            }, 1000)
        },
        pwInput1 (e) {
            if (e) {
                this.pwType1 = 'password'
            } else {
                this.pwKey++
                this.pwType1 = 'text'
            }
        },
        pwInput2 (e) {
            if (e) {
                this.pwType2 = 'password'
            } else {
                this.pwKey++
                this.pwType2 = 'text'
            }
        },
        pwInput3 (e) {
            if (e) {
                this.pwType3 = 'password'
            } else {
                this.pwKey++
                this.pwType3 = 'text'
            }
        },
        handlePhone(value){
            const pattern = /^[0-9]\d*$/g
            if (pattern.test(value)) {
                // 双向绑定
                this.ruleForm.phone = value
            } else {
                // 输入值不为正整数，则从中提取出数字并拼接为字符串
                const num = value.match(/\d+/g)
                this.ruleForm.phone = num ? num.join('') : ''
            }
        }
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.password-page{
    margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/userInfo/components/updatePassword.vue